<template>
  <div id="app " class="app">
    <keep-alive v-if="isRouterAlive">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { setupImageGuard } from './utils/imageGuard';
import { normalizeWxEntryUrl } from './utils/wechatScan';

export default {
  name: "",
  props: {},
  data() {
    return {
      _beforeUnload_time: '',
      _gap_time: '',
      isRouterAlive: true,
      _teardownImageGuard: null
    };
  },
  provide() { return { reload: this.reload }; },
  created() {

  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    }
  },
  mounted() {
    if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
      window.entryUrl = normalizeWxEntryUrl(location.href);
    }
    this._teardownImageGuard = setupImageGuard();
  },
  computed: {},
  watch: {},
  destroyed() {
    this._teardownImageGuard?.();
    // window.removeEventListener('beforeunload')
    // window.removeEventListener('unload')
  }
};
</script>

<style lang='scss'>
@import "./styles/ui";
@import "./styles/common";
@import "./styles/imageGuard";

// 防止微信浏览器字体大小设置影响页面布局
html {
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}

body {
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}

// 强制设置根元素字体大小，不受微信设置影响
html, body {
  font-size: 16px !important;
}

// 高度
html,
body,
.app {
  height: 100%;
  background-color: #F8F8F8;
  // font-family: PingFangSC-Medium;
  // font-family: 'Regular';
  // letter-spacing: 1px;
  font-family: Helvetica Neue, Helvetica, sans-serif;
}

#app {
  padding-bottom: 20px;
}

* {
  margin: 0;
  padding: 0;
  // 防止继承微信设置的字体大小
  -webkit-text-size-adjust: none !important;
  -ms-text-size-adjust: none !important;
  text-size-adjust: none !important;
}

// 为所有元素设置基础字体大小，防止微信字体设置影响
*, *::before, *::after {
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}

// 针对微信浏览器的特殊处理
#app {
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  font-size: 16px !important;
}

::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-track {
  background-color: none;
}

::-webkit-scrollbar-thumb {
  background-color: none;
}

::-webkit-scrollbar-thumb:hover {
  background-color: none;
}

::-webkit-scrollbar-thumb:active {
  background-color: none;
}

/* ========== 微信浏览器字体大小防护 ========== */
/* 针对微信浏览器的特殊处理 */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  html, body {
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    font-size: 16px !important;
  }
}

/* 强制所有文本元素不受微信字体设置影响 */
h1, h2, h3, h4, h5, h6, p, span, div, a, button, input, textarea, select {
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}

/* 针对vant组件的字体大小保护 */
.van-button, .van-cell, .van-field, .van-nav-bar, .van-tabbar, .van-tab {
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}
</style>